<template>
  <div class="main">
    <div class="title">气象数据</div>
    <div class="row row3 card list-wrap ">
      <div class="data-item" v-for="item in weatherData" :key="item.imgUrl">
        <span class="img"><img :src="`${item.imgUrl}`" /> </span>
        <span class="value">{{ item.value != null ? item.value : '-' }}</span>
        <span class="unit">{{ item.unit }}</span>
      </div>
    </div>
    <div class="title">灌溉监测</div>
    <div class="row row3 card list-wrap">
      <div class="data-item" v-for="item in detectionData" :key="item.imgUrl">
        <span class="img"><img :src="`${item.imgUrl}`" /> </span>
        <span class="value">{{ item.value != null ? item.value : '-' }}</span>
        <span class="unit">{{ item.unit }}</span>
      </div>
    </div>
    <div class="row  flex program">
      <div class="title">程序列表</div>
      <div class="right">
        <span class="button" @click="handleProcedure">管理程序</span>
        <span class="button" @click="handleProgram">编程</span>
      </div>
    </div>
    <!-- 2 -->
    <div class="row row3 card">
      <div class="top">
        <div class="left">
          <div class="icon">
            <i class="iconfont icon-jiangyuliang"></i>
          </div>
          <div class="txt">雨量传感器</div>
        </div>
        <div class="right">
          <div :class="['switch', switchRain ? 'open' : 'clo']">
            {{ switchRain ? "已开启" : "未开启" }}
          </div>
        </div>
      </div>
    </div>
    <!-- 3 -->
    <div class="row row4 card">
      <div class="top">
        <div class="left">
          <div class="icon">
            <i class="iconfont icon-guanqu"></i>
          </div>
          <div class="txt">自动灌溉</div>
        </div>
        <div class="right">
          <div :class="['switch', switchAuto ? 'open' : 'clo']">
            {{ switchAuto ? "已开启" : "未开启" }}
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="left">
          <div class="tit">启动时间域</div>
          <div class="time">
            {{ autoWork.start_time }}-{{ autoWork.end_time }}
          </div>
        </div>

        <div class="right middle">
          <div class="tit">阀值</div>
          <div class="time">{{ waterGuid }}kpa</div>
        </div>

        <div class="right">
          <div class="tit">水势</div>
          <div class="time">{{ water_flow == null ? '-' : water_flow }}kpa</div>
        </div>
      </div>
    </div>
    <!-- 4 -->
    <div class="row row4 card">
      <div class="top">
        <div class="left">
          <div class="icon">
            <i class="iconfont icon-naozhong"></i>
          </div>
          <div class="txt">定时灌溉</div>
        </div>
        <div class="right">
          <div :class="['switch', switchTime ? 'open' : 'clo']">
            {{ switchTime ? "已开启" : "未开启" }}
          </div>
        </div>
      </div>
      <div class="autowork">
        <div class="aw_top aw_row aw_row1">
          <div class="tit">灌溉时间</div>
          <div class="times">
            <div class="time_item" v-for="(item, index) in setTimes" :key="index">
              <span>{{ index + 1 }}</span>
              <span>{{ item == "-1:-1" ? "-:-" : item }}</span>
            </div>
          </div>
        </div>

        <div class="aw_bottom aw_row aw_row3">
          <div class="tit">每周灌溉</div>
          <div class="time">{{ week }}</div>
        </div>
      </div>
    </div>

    <div class="row row2 card">
      <div class="show_time">
        <div class="item" v-for="item in showTime" :key="item.label">
          <div class="label">{{ item.label }}</div>
          <div class="value">{{ item.value }}</div>
        </div>
      </div>
    </div>

    <div class="row program_status card">
      <div class="left">程序状态 <span v-show="status">- 第{{ currentGroup || 0 }}组（共{{ totalGroup }}组）</span></div>
      <div :class="['right', status == 1 ? 'isWoring' : status == 2 ? 'stopping' : 'noWorking']">{{ status == 1 ?
        '灌溉中' : status == 2 ? '暂停中' : '未执行' }}</div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    refreshing: {
      type: Boolean,
      default: false
    },
    type: {
      type: [String, Number],
      default: null
    },
    hasDeviceChange: {
      type: Boolean,
      default: false
    },
  },

  data () {
    const requireImg = (name) => require(`@/assets/images/${name}`)

    return {
      no: null,
      switchValve: false, // 阀门开关
      switchGuan: false, // 灌溉开关
      switchRain: false, // 雨量开关
      switchAuto: false, // 自动开关
      switchTime: false, // 定时开关
      autoWork: {
        end_time: "00:00",
        minute_num: 0,
        start_time: "00:00",
      }, // 自动灌溉信息
      waterGuid: 0, // 水势灌溉指导值 阀值
      water_flow: 0, // 水势值
      isOdd: true, // 是否是基数
      week: "", // 每周几
      setTimes: ["00:00", "00:00", "00:00", "00:00"],
      startingTime: 0, //已灌溉时间
      fluidLevel: 0, //  水位
      realTimeFlow: 0, //  实时流量
      totalFlow: 0,// 总流量
      pressure: 0,  // 压力
      cycleDate: 0,
      weatherData: [
        { key: 'temperature', imgUrl: requireImg('23_wendu.png'), value: null, unit: '℃' },
        { key: 'humidity', imgUrl: requireImg('23_shidu.png'), value: null, unit: '%' },
        { key: 'windSpeed', imgUrl: requireImg('23_fengsu.png'), value: null, unit: 'm/s' },
        // { key: '', imgUrl: requireImg('23_fengxiang.png'), value: null, unit: '°' },
        { key: 'rainfall', imgUrl: requireImg('23_jiangyuliang.png'), value: null, unit: 'mm' },
        { key: 'illuminance', imgUrl: requireImg('23_guangzhaoqiangdu.png'), value: null, unit: 'Lux' },
        { key: 'atmosphericPressure', imgUrl: requireImg('23_daqiyali.png'), value: null, unit: 'hPa' },
        { key: 'ultravioletRays', imgUrl: requireImg('23_ziwaixian.png'), value: null, unit: 'uW/cm²' },
      ],
      detectionData: [
        { key: 'realTimeFlow', imgUrl: requireImg('23_liuliang.png'), value: null, unit: 'm³/h' },
        { key: 'totalFlow', imgUrl: requireImg('23_yewei.png'), value: null, unit: 'm³' },
        { key: 'level', imgUrl: requireImg('23_zongliuliang.png'), value: null, unit: 'm' },
        { key: 'pressure', imgUrl: requireImg('23_yali.png'), value: null, unit: 'MPa' },
      ],
      status: false,
      currentGroup: null, // 当前执行到第几组
      totalGroup: 0, // 共多少组
      showTime: [
        {
          key: "totalTime",
          label: "共计用时",
          value: "",
        },
        {
          key: "startTime",
          label: "开始时间",
          value: "",
        },
        {
          key: "remainderTime",
          label: "剩余时间",
          value: "",
        },
        {
          key: "endTime",
          label: "完成时间",
          value: "",
        },
      ],
    };
  },

  watch: {
    refreshing (val) {
      console.log("监听到刷新:", val);
      val && this.init()
    },

    hasDeviceChange (val) {
      console.log("监听到设备切换:", val);
      this.no = localStorage.getItem("no");
      val && this.init()
    }
  },

  mounted () {
    this.no = localStorage.getItem("no");

    if (!this.no)
      return this.$toast({
        message: `异常：设备号不能为空`,
        duration: 3000,
      });

    console.log("12312312313");

    this.init()
  },

  methods: {
    async init () {
      this.$toast.loading({
        message: '设备读取中...',
        forbidClick: true,
        duration: 0,
      });
      // 读取首屏数据
      await this.getFirstScreenData()

      setTimeout(() => {
        this.$toast.clear();
      }, 2000)
    },


    // 获取首页数据
    async getFirstScreenData () {
      await this.$api.lgV4_getFirstScreenData({
        gatewayNo: this.no
      }).then(res => {
        if (res.errcode === 0) {
          console.log("进来了111111");
          const {
            programStatus: {
              status, // 开启状态
              runTime,// 已运行时长
              totalGroup, // 共多少组
              groupIndex, // 当前第几组
              proId, // 程序序号
            }, // 程序状态
            groupStatus, // 组的状态
            sensorList, // 传感器检测值
            requireManure,
            totalTime,
            remainderTime,
            bumpStatusList, // 水泵
            manureList, // 施肥机
            manureStatusList,// 施肥机
            valStatusList, // 阀门
            level = [0, 0], // 水位传感器
            weather,
          } = res.data
          this.bumpStatusList = [...bumpStatusList]
          this.manureStatusList = [...(manureStatusList || manureList || [])]
          this.valStatusList = [...valStatusList]
          this.proId = proId + 1
          this.requireManure = requireManure
          this.groupStatus = { ...groupStatus }

          // 时间展示
          this.showTime.map(o => {
            if (o.key === 'startTime' || o.key === "endTime") {
              let data = res.data[o.key] ?
                res.data[o.key].indexOf(" ") > -1 ?
                  res.data[o.key].split(" ").reverse().join(" ") :
                  "" : "";
              o.value = data ? data : null
            } else {
              o.value = this.getTime(res.data[o.key])
            }
          })


          this.weatherData.map(o => {
            o.value = weather?.[o?.key] != null ? Number(weather?.[o?.key]).toFixed(2) : weather?.[o?.key]
          })

          // 正在执行的组 共有多少组
          this.currentGroup = groupIndex !== null ? groupIndex + 1 : 0
          this.status = status // 0关闭 1开启 2暂停 3停止
          this.runTime = (runTime / 60).toFixed(2)
          this.totalGroup = totalGroup


          this.detectionData[0].value = sensorList?.[0]?.realTimeFlow
          this.detectionData[1].value = sensorList?.[0]?.totalFlow
          this.detectionData[2].value = level?.[0]
          this.detectionData[3].value = sensorList?.[0]?.pressure  == '3.27' ? 'null': sensorList?.[0]?.pressure



          if (totalTime) {
            // 开始的时间 = 总的时间 -  剩余时间
            this.stime = this.getTime(totalTime - remainderTime)
            this.etime = this.getTime(totalTime)
          }

          const loadTime = totalTime - (remainderTime)
          this.process = ((groupStatus.havRunTime / (groupStatus.setTime)).toFixed(1)) * 100
          const t = groupStatus.havRunTime ? groupStatus.havRunTime / 60 : 0;
          this.loadMin = String(t).indexOf(".") > -1 ? t.toFixed(2) : t;

          this.totalMin = Math.ceil(groupStatus.setTime / 60)


          const irrigateData = { ...(res.data?.irrigateData ?? {}) }
          const {
            autoSwitch,
            guideWaterPotential,
            rainfallSwitch,
            regularStart1,
            regularStart2,
            regularStart3,
            regularStart4,
            regularSwitch,
            startTime,
            endTime,
            weekRegular,
            waterPotentialValue
          } = irrigateData
          const cronArr = weekRegular?.split("");
          console.log("cronArr:", cronArr);
          if (cronArr) {
            let txt = ""
            cronArr.map((o, i) => {
              if (o == 1) { txt += `周${this.$noToChinese(i + 1) == "七" ? "日" : this.$noToChinese(i + 1)}  ` }
            })
            console.log("txt:", txt);
            this.week = txt
          }

          this.setTimes = [regularStart1, regularStart2, regularStart3, regularStart4,]
          this.switchTime = regularSwitch //定时开关
          this.switchRain = rainfallSwitch;
          this.switchAuto = autoSwitch;//水势开关
          this.water_flow = guideWaterPotential;
          this.autoWork.start_time = startTime;
          this.autoWork.end_time = endTime;
          this.waterGuid = waterPotentialValue
        } else {
          setTimeout(() => {
            this.$toast({
              message: `获取首屏数据异常：${res.errmsg}`,
              duration: 1500,
            })
          }, 10);
        }
      })
    },


    // 点击编程
    handleProgram () {
      this.$router.push({
        path: '/yuanlinkongzhiqi',
        query: {
          data: JSON.stringify({ index: 0 })
        }
      })
    },


    // 管理程序
    handleProcedure () {
      this.$router.push({
        path: '/lunguan',
        query: {
          data: JSON.stringify({ index: 0 })
        }
      })
    },

    getTime (second) {
      second = Number(second);
      let h = 0,
        m = 0,
        s = 0;

      const u_h = 60 * 60;
      const u_m = 60;

      h = Math.floor(second / u_h);
      m = Math.floor((second - h * u_h) / u_m);
      s = second - h * u_h - m * u_m;

      const M = String(m).padStart(2, "0");
      const S = String(s).padStart(2, "0");
      if (h) {
        const H = String(h).padStart(2, "0");
        return `${H}:${M}:${S}`;
      }

      return `${M}:${S}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  height: 100%;
  background: #f0f5fc;
}

.top_box {
  height: 80px !important;
  color: #ffffff;
  font-size: 16px !important;
  padding: 10px;
  box-sizing: border-box;

  >.title {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
  }
}

.row1 {
  position: relative;
  display: flex;
  justify-content: space-between;

  .icon-shezhi1 {
    position: absolute;
    font-size: 26px;
    top: 11px;
    left: 16px;
  }

  .btn1 {
    position: relative;

    &:last-child .txt {
      padding-left: 38px;
    }
  }

  .switchBtn {
    position: absolute;
    top: 1px;
    left: 1px;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    height: 51px;
    width: 51px;
    text-align: center;
    line-height: 51px;
    color: #ffffff;
  }

  .on {
    background: linear-gradient(132.98deg, #2ad49a -12.22%, #13b28c 163.13%);
  }

  .off {
    background: #e25c5c;
  }
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  font-size: 16px;
  box-shadow: 0px 10.7278px 31.209px rgba(57, 129, 246, 0.05);
  border-radius: 25.9175px;
  width: 40%;
  height: 52px;
  text-align: center;
}

.card {
  background: #ffffff;
  box-shadow: 0px 10.46px 30.43px rgba(57, 129, 246, 0.05);
  padding: 0px 15px 15px;
  box-sizing: border-box;

  &:last-of-type {
    margin-bottom: 20px;
  }

  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      background: #1e98f6;
      border-radius: 3px;
      color: #ffffff;
      margin-right: 12px;
    }

    .left {
      display: flex;
      // flex: 4;
    }

    .right {
      // flex: 1;
    }

    .txt {
      font-size: 16px;
    }

    .switch {
      border-radius: 101.778px;
      padding: 3px 20px;
      font-size: 12px;
    }

    .open {
      color: #29bc7e;
      background: rgba(27, 224, 141, 0.2);
    }

    .clo {
      background: #fdf8f3;
      color: #edb077;
    }
  }

  .bottom {
    display: flex;
    margin-top: 12px;
    font-size: 16px;

    .left {
      flex: 1;
      text-align: center;
    }

    .right {
      flex: 1;
      border-left: 0.4px solid rgba(111, 126, 168, 0.6);
      text-align: center;
    }

    .tit {
      color: #6f7ea8;
      margin-bottom: 8px;
    }
  }

  .autowork {
    display: block;
    font-size: 16px;

    .left,
    .right,
    .middle {
      width: 100%;
    }
  }

  .aw_row {
    padding: 12px 0;
    border-bottom: 0.4px solid rgba(111, 126, 168, 0.6);

    &:last-child {
      border: none;
    }

    .tit {
      color: #6f7ea8;
      width: 65px;
    }

    .times {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .time_item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50%;
        text-align: center;
        margin-top: 12px;
        white-space: normal;

        span {
          flex: 1;

          &:first-child {
            text-align: center;
          }
        }
      }
    }
  }

  .aw_row2,
  .aw_row3 {
    display: flex;
    align-items: center;

    .time {
      margin-left: 30px;
    }
  }
}

.line {
  width: 100%;
  height: 0.5px;
  background: rgba(111, 126, 168, 0.6);
  margin: 14px 0;
}

.sleep {
  color: #ffffff;
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
}

.title {
  color: #000;
  font-weight: bold;
  margin: 10px 0;

  &:first-of-type {
    margin-top: 0;
  }
}

.program {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;

  .title {
    margin: 0;
  }

  .right {
    display: flex;
    align-items: center;

    .button {
      color: #1e98f6;
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.list-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 10px 8px !important;

  .data-item {
    display: flex;
    width: 50%;
    align-items: center;
    justify-content: space-between;
    padding-top: 12px;

    .img {
      width: 24px;
    }

    img {
      width: 24px;
      height: 24px;
    }

    .value {
      width: calc(100% - 24px - 40%);
      text-align: center;
      padding: 0 3px;
    }

    .unit {
      width: 40%;
    }
  }
}

.show_time {
  display: flex;
  width: 100%;
  font-size: 16px;
  border: 0.5px solid #888888;

  .item {
    flex: 1;
    text-align: center;
    border-right: 0.5px solid #888888;

    &:last-child {
      border: none;
    }

    .label {
      color: rgba(51, 51, 51, 1);
      padding: 8px;
      font-size: 14px;
      border-bottom: 0.5px solid #888888;
    }

    .value {
      color: rgba(136, 136, 136, 1);
      padding: 9px 0;
      font-size: 14px;
    }
  }
}

.program_status {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .right {
    color: #2ad49a;
    background: rgba(42, 212, 154, 0.13);
    padding: 1px 15px;
    border-radius: 10px;
    font-size: 13px;
  }

  .noWorking {
    color: #edb077;
    background: #fcf3eb;
  }
}

.title_row {
  padding-top: 10px;
}
</style>
